import React, { Fragment } from 'react';
import Sanitise from '../utilities/Sanitise';
function FormHeader(props) {
  const TitleElement = props.isPageTitle ? 'h1' : 'h2';

  return (
    <div className="form__header">
      {props.title && <TitleElement className="form__title">{props.title}</TitleElement>}
      {props.introduction && <Sanitise string={props.introduction} />}
      {props.children}
    </div>
  );
}

export default FormHeader;
